import React from 'react';
import CustomSelect from './CustomSelect';
import { brandSelect } from '../resources/brandList';

const BrandSelect = ({ selectedBrand, onFormBrandSelectChange }) => {
  return (
    <CustomSelect
      selectValue={selectedBrand}
      selectOnChange={onFormBrandSelectChange}
      menuItems={brandSelect}
    />
  );
};

export default BrandSelect;
